import ApiService from './';
import { ComposeEmailParams, SendBulkEmailsParams } from '../params/redux/email';
/**
 * @heading1: File API service.
 * @paragraph: This module provides a set of methods to interact with the File API.
 * It handles operations like Fetching file details and create files etc.
 */
const EmailApi = {
    /**
     * @heading3: Fetch Files
     * @paragraph: Sends a POST request to retrieve all files available for the user.
     * @param: {string} token - The user's authentication token.
     * @param: {number} client_id - The parameters required id on which the files will be fetch.
     * @returns: {Promise<unknown[]>} - The response containing a list of all files.
     * @separator:
     */
    fetchUserIntegration: (token: string, client_id: number) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'get-client-integrations',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    composeEmail: (token: string, data: ComposeEmailParams) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'send-email-client',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchMailMessages: (token: string, email_id: number, client_id: number) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'get-mail-messages',
            method: 'post',
            token,
            data: { email_id, client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    replyToThread: (token: string, data: ComposeEmailParams) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'reply-to-thread',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    markAllMailsAsRead: (token: string) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'get-files',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    deleteMail: (token: string) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'get-files',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchUserMails: (token: string, client_id: number, deal_id: number | null, lead_id: number | null) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'get-user-mail',
            method: 'post',
            token,
            data: { client_id, deal_id, lead_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchThreadMessages: (token: string, client_id: number, thread_id: number) => {
        // Perform a POST request to fetch files with the provided data
        return ApiService.apiHit({
            url: 'fetch-message-thread',
            method: 'post',
            token,
            data: { client_id, thread_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    sendBulkEmails: (token: string, data: SendBulkEmailsParams) => {
        return ApiService.apiHit({
            url: 'send-bulk-email-to-leads',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchGlobalThreads: (token: string) => {
        return ApiService.apiHit({
            url: 'get-thread-global',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default EmailApi;
